import React from 'react'
//import { Icon } from '../../../../components'
import './index.less'

const clsPrefix = 'c-manage-feature-description-item'
const ManageFeatureDescriptionItem: React.FC<{
  iconName?: string,
  icon?: React.ReactNode,
  content: string | React.ReactNode,
  className?: string,
  style?: React.CSSProperties,
  iconStyle?: React.CSSProperties,
  iconClassName?: string,
}> = ({
  iconName,
  content,
  className = '',
  style = {},
  icon,
  iconStyle = {},
  iconClassName = ''
}) => {
  return (
    <div className={`${clsPrefix} ${className}`} style={style}>
      <div className={`${clsPrefix}__icon`}>
        <div className={iconClassName} style={iconStyle}></div>
        {/*{ icon || (iconName && <Icon name={iconName} className={iconClassName} style={iconStyle} />)}*/}
      </div>
      <p className={`${clsPrefix}__content`}>{content}</p>
    </div>
  )
}

export { ManageFeatureDescriptionItem }
